/**
 * Parse a WebVTTCuePayloadBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed WebVTTCuePayloadBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function payl(view) {
    return {
        cueText: view.readUtf8(-1),
    };
}
;
//# sourceMappingURL=payl.js.map